import { render } from "./redefinir.vue?vue&type=template&id=3ac1b8d6"
import script from "./redefinir.vue?vue&type=script&lang=js"
export * from "./redefinir.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__